export function cc(...args) {
  return args.join(' ');
}
